<template>
  <footer class="main">
    <div class="mr-auto">
      <a class="navbar-brand formability-logo" href="/app/assets/config" aria-label="Go to Formability Home">
        <span class="sr-only">Formability</span>
      </a>
      <div class="copy">Copyright &copy; {{new Date().getFullYear()}} Formability - All Rights reserved</div>
    </div>

    <div class="align-right" v-if="releaseVersion">
      Release Version {{ releaseVersion }}
    </div>
  </footer>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    computed: {
      releaseVersion(): string {
        return (<any>window).releaseVersion;
      },
    },
  });
</script>